var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'absolute',
    'flex',
    'items-center',
    'justify-center',
    'p-0.875',
    'rounded-full',
    'top-0',
    'left-0',
    'bottom-0',
    'right-0' ]},[_c('OzButton',{class:['rounded-full', _vm.buttonColorClass, _vm.buttonHoverColorClass, _vm.buttonIconColorClass],attrs:{"type":"custom","icon-size":16,"size":"small","icon-name":_vm.iconName,"color-scheme":"secondary"},on:{"click":function($event){return _vm.$emit('click', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }